export default class FormField {
    constructor(id, label, name, type, options, required, order, value) {
        this.id = id;
        this.label = label;
        this.name = name;
        this.type = type;
        this.options = options;
        this.required = required;
        this.order = order;
        this.value = value;
    }
}
